/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Code from 'components/Code';
import Table, {Row, Column} from 'components/Table';
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    p: "p",
    ol: "ol",
    li: "li",
    pre: "pre",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h3, {
      children: [_jsx(_components.code, {
        children: "styled"
      }), "(", _jsx(_components.code, {
        children: "styled"
      }), ")"]
    }), "\n", _jsxs(_components.p, {
      children: ["这是默认导出。这是我们用来创建 ", _jsx(_components.code, {
        children: "styled.tagname"
      }), " 辅助方法的底层工厂。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This is the default export.\nThis is a low-level factory we use to create the ", _jsx(_components.code, {
        children: "styled.tagname"
      }), " helper methods."]
    }), "\n", _jsx(Table, {
      head: ['Arguments', 'Description'],
      children: _jsxs(Row, {
        children: [_jsx(Column, {
          children: _jsxs(_components.ol, {
            children: ["\n", _jsxs(_components.li, {
              children: [_jsx(Code, {
                children: "component"
              }), " / ", _jsx(Code, {
                children: "tagname"
              })]
            }), "\n"]
          })
        }), _jsx(Column, {
          children: _jsxs(_components.p, {
            children: ["Either a valid react component or a tagname like ", _jsx(Code, {
              children: "'div'"
            }), "."]
          })
        })]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["返回一个接受标记模板字面量并将其转换为 ", _jsx(_components.code, {
        children: "StyledComponent"
      }), " 的函数。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Returns a function that accepts a tagged template literal and turns it into a ", _jsx(_components.code, {
        children: "StyledComponent"
      }), "."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "// import styled from 'styled-components'\n\nconst Button = styled.button`\n  background: #BF4F74;\n  border-radius: 3px;\n  border: none;\n  color: white;\n`\n\nconst TomatoButton = styled(Button)`\n  background: tomato;\n`\n\nrender(\n  <>\n    <Button>I'm purple.</Button>\n    <br />\n    <TomatoButton>I'm red.</TomatoButton>\n  </>\n)\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["你可以在 ", _jsx(_components.a, {
        href: "/docs/basics#getting-started",
        children: "入门"
      }), " 部分看到这个方法的介绍。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can see this method being introduced in the ", _jsx(_components.a, {
        href: "/docs/basics#getting-started",
        children: "Getting started"
      }), " section."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
